import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import es from 'vee-validate/dist/locale/es';
import VeeValidate, { Validator } from 'vee-validate';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'form-valid',
    invalid: 'form-invalid'
  }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCvf0s58exgdDzlmdyj2NMvlSYolryD9zA'
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Validator.localize('es', es);

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import('./assets/fonts/styles.css');

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')